export const downArrowIcon = require('./downArrowIcon.svg');
export const moreInfoIcon = require('./moreInfoIcon.svg');
